import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  UserId: string;
  RoleId: string;
  exp: number; // Expiration time
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
   
    return decoded.exp < currentTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true; // Treat token as expired if decoding fails
  }
};


export const getUserIdFromToken = (): string | null => {
  const token = localStorage.getItem('token');
  if (!token || isTokenExpired(token)) {
    return null; // Token is missing or expired
  }
  try {
    const decoded = jwtDecode<DecodedToken>(token);
  return decoded.UserId;  
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};
